import { ResponseMessageWithInternalStatus } from "../dto/response-message-with-internal-status.dto";

export interface TipoMoneda {
  id: number;
  denominacion: string;
  codigoAfip: string;
}

export interface TipoMonedas {
  listadoTipoMoneda: TipoMoneda[];
}

export interface ListadoTipoMonedaResponse extends ResponseMessageWithInternalStatus{
  listadoTipoMoneda: {
    id: number;
    denominacion: string;
    codigoAfip: string;
  }[]
}

export interface TipoMonedasState {
  tipoMonedas: TipoMoneda[];
  error: boolean;
  debugMessage?: any;
}

export const initialTipoMonedaState: TipoMonedasState = {
  tipoMonedas: [],
  error: false,
  debugMessage: null
};
